<template>
  <v-dialog dark v-model="internalDialog" :origin="origin" transition="scale-transition" fullscreen>
    <v-btn @click="closeDialog" x-large style="z-index: 1000" icon absolute top right color="white">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <shift-management-main-dialog-create
      v-if="dialogSessionKey > 0"
      :key="dialogSessionKey"
      :pre-selected-studio="preSelectedStudio"
      :existing-plans="existingPlans"
      :existing-plans-studio-id="existingPlansStudioId"
      @open-existing-month="openExistingMonth"
      @close-dialog="closeDialog">
    </shift-management-main-dialog-create>
  </v-dialog>
</template>

<script>
import shiftManagementMainDialogCreate from "./shiftManagementMainDialogCreate.vue"

export default {
  components: {
    shiftManagementMainDialogCreate,
  },
  name: "ActionDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    origin: {
      type: String,
      default: "center center",
    },
    preSelectedStudio: {
      type: String,
      default: null,
    },
    existingPlans: {
      type: Array,
      default: () => [],
    },
    existingPlansStudioId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      internalDialog: this.value,
      dialogSessionKey: this.value ? 1 : 0,
    }
  },
  watch: {
    value(val, oldVal) {
      if (val && !oldVal) this.dialogSessionKey += 1
      this.internalDialog = val
    },
    internalDialog(val) {
      this.$emit("input", val)
    },
  },
  methods: {
    closeDialog() {
      this.internalDialog = false
    },
    openExistingMonth(payload) {
      this.internalDialog = false
      this.$emit("open-existing-month", payload)
    },
  },
}
</script>
